<template>
    <span>
        <br>
            <span v-if="qstatus.id>=0" class="qa">
                Quizantwort:
                <span v-if="qstatus.answerRight==true">
                    <font-awesome-icon icon="thumbs-up" size="lg" class="icon"/>

                    <!-- Richtig-->
                </span>
                <span v-if="qstatus.answerRight==false">
                    <font-awesome-icon icon="thumbs-down" size="lg" class="icon"/>

                    <!-- Falsch-->
                 </span>
             </span>
     </span>
</template>
<script type="text/babel">
    export default {
        name: 'Quizstatus',
        props: ['waypointId'],
        computed: {
            qstatus: function () {
                let self = this;
                return this.$root.solvedQuizes.find((item) => item.id === self.waypointId)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .qa {
        font-size: 13px;
        font-style: italic;
        margin-left: 20px;

    }

    .icon {
        margin-left: 10px;
    }
</style>